import { request } from "../helpers/axios.new";

export const GET_ALL_INVOICES = () => {
  return request({
    url: "/payment/invoice/all",
    method: "GET",
  });
};
